import React from 'react';
import styles from './Landing.scss';

const PrivacyPolicy = () => (
  <div className={styles.Landing}>
    <h1>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h1>

    <p>
      Настоящая Политика конфиденциальности (далее – Политика) определяет порядок и условия
      обработки Обществом с ограниченной ответственностью «Недвекс» (ОГРН 1162366056830) (далее –
      Оператор), информации о физическом лице, которая может быть получена Оператором от этого
      физического лица (далее – Пользователь), при использовании функций сайта. Любое пользование
      сайта означает безоговорочное согласие Пользователя с настоящей Политикой и указанными в ней
      условиями обработки его персональных данных. В случае несогласия с этими условиями
      Пользователь должен воздержаться от пользования сайтом.
    </p>

    <h3>1. Условия сбора и хранения данных</h3>

    <p>
      Пользуясь сайтом или приобретая услуги, предлагаемые на сайте, а также отвечая на необходимые
      вопросы в анкете при регистрации и/или оформлении покупки (услуги), пользователь подтверждает,
      что дает согласие Оператору и уполномоченным им лицам, на обработку персональных данных, а
      также что является совершеннолетним и дееспособным лицом.
    </p>

    <p>
      Пользователь дает свое согласие Оператору и уполномоченным им лицам на обработку полученной
      информации, включая сбор, хранение, использование, систематизацию, накопление, уточнение
      (обновление, изменение), использование, распространение, обезличивание, блокирование,
      уничтожение персональных данных, оставленных при использовании средств автоматизации,
      систематизацию и формирование базы данных пользователей сайта, составления статистической
      отчетности, а также на получение информации о проводимых исследованиях и иных предложений от
      Оператора и уполномоченных им лиц.
    </p>

    <p>
      Настоящим Пользователь предоставляет свое согласие и разрешает Оператору и уполномоченным им
      лицам обрабатывать свои персональные данные, в том числе: (Имя; Фамилия; Отчество; Пол;
      Контактный телефон; Электронная почта; Сфера деятельности; Прочие).
    </p>

    <p>
      Пользователь подтверждает, что дает согласие и предоставляет право Оператору и уполномоченным
      им лицам осуществлять автоматизированную и неавтоматизированную обработку, включая сбор,
      систематизацию, накопление, хранение, уточнение (обновление, исправление), использование,
      распространение, обезличивание, блокирование, уничтожение персональных данных, указанных в
      анкете, в целях мероприятий, направленных на формирование базы данных участников, составления
      статистической отчетности, проведения маркетинговых исследований, а также осуществления
      взаимодействия с пользователем, в том числе по сетям электронной связи, включая направление
      SMSсообщений и электронных писем, до отзыва такого согласия.
    </p>

    <p>
      Пользователь подтверждает свое согласие с тем, что Оператор и уполномоченные им лица вправе
      взаимодействовать с Пользователем путем осуществления прямых контактов с помощью различных
      средств связи, включая, но, не ограничиваясь: почтовая рассылка, электронная почта, сеть
      Интернет и др.
    </p>

    <p>
      Пользователь вправе в любое время отозвать свое согласие, путем направления соответствующего
      письменного обращения (уведомления об отзыве согласия на обработку персональных данных) по
      юридическому адресу Оператора, указанному в разделе 12 настоящей Политики.
    </p>

    <p>
      Пользователь согласен с тем, что предоставленные им персональные данные будут удалены по его
      письменному требованию в срок, не превышающий 30 дней с даты получения требования об их
      уничтожении.
    </p>

    <p>
      Пользователь предоставляет Оператору согласие на обработку своих персональных данных на срок
      10 лет с даты передачи его данных Оператору, но в любом случае, не более срока, необходимого
      для реализации цели обработки персональных данных, если отсутствуют законные основания для
      дальнейшей обработки. В случае, если по истечении вышеуказанного срока согласие на обработку
      персональных данных не отозвано, действие согласия пролонгируется еще на 10 лет.
    </p>

    <p>Количество пролонгаций не ограничено.</p>

    <p>
      Оператор оставляет за собой право использовать присланную информацию указанными выше способами
      без специального согласования с Пользователями и без выплаты последующего денежного
      вознаграждения Пользователю.
    </p>

    <p>
      Оператор сохраняет за собой право периодического обновления или внесения изменений в
      вышеизложенные положения в одностороннем порядке.
    </p>

    <h3>2. Категории собираемых данных</h3>

    <p>
      Категории Персональных данных, сбор которых осуществляет сайт (самостоятельно или при
      посредничестве третьих лиц), включают: Файлы «cookie» и данные об использовании сетевых
      ресурсов.
    </p>

    <p>
      Прочие собираемые Персональные данные могут описываться в других разделах настоящих правил
      обеспечения конфиденциальности персональных данных или в специальном пояснительном тексте в
      контексте сбора данных.
    </p>

    <p>
      Персональные данные могут предоставляться Пользователем самостоятельно или их сбор может
      автоматически осуществлять сайт при его использовании. Если не указано иное, сайт использует
      файлы «cookie» (или другие средства отслеживания) для идентификации Пользователей и
      запоминания установленных ими глобальных параметров настройки исключительно в целях
      предоставления услуги, требующейся Пользователю.
    </p>

    <p>
      Пользователи несут ответственность за Персональные данные третьих лиц, которые они получают,
      публикуют или предоставляют другим лицам, используя сайт, и подтверждают, что у них имеется
      согласие третьего лица на предоставление данных Оператору.
    </p>

    <h3>3. Порядок обработки персональных и иных данных</h3>

    <p>
      3.1. Оператор обязуется использовать Персональные данные в соответствии с Законом «О
      персональных данных» Российской Федерации и внутренними документами Оператора.
    </p>

    <p>
      3.2. В отношении Персональных данных сохраняется их конфиденциальность, кроме случаев, когда
      указанные данные являются общедоступными.
    </p>

    <p>3.3. Оператор имеет право сохранять архивную копию Персональных данных.</p>

    <p>
      Оператор имеет право хранить Персональные данные на серверах вне территории Российской
      Федерации.
    </p>

    <p>
      3.4. Оператор имеет право передавать Персональные данные Пользователя без согласия
      Пользователя следующим лицам:
    </p>

    <p>
      3.4.1 государственным органам, в том числе органам дознания и следствия, и органам местного
      самоуправления по их мотивированному запросу;
    </p>

    <p>
      3.4.2 в иных случаях, прямо предусмотренных действующим законодательством Российской
      Федерации.
    </p>
    <p>
      3.5. Оператор имеет право передавать Персональные данные третьим лицам, не указанным в п. 3.4.
      настоящей Политики конфиденциальности, в следующих случаях:
    </p>
    <p>3.5.1. Пользователь выразил свое согласие на такие действия;</p>
    <p>
      3.5.2. Передача необходима в рамках использования Пользователем Сайта или оказания Услуг
      Пользователю;
    </p>
    <h3>4. Использование собранных данных</h3>
    <p>
      Сбор данных, касающихся Пользователя, осуществляется для того, чтобы дать возможность
      Оператору предоставлять услуги, а также в следующих целях: аналитика, регистрация и
      аутентификация.
    </p>
    <p>
      Персональные данные, используемые для каждой цели, описываются в соответствующих разделах
      настоящего документа.
    </p>
    <h3>5. Подробная информация об обработке Персональных данных</h3>
    <p>5.1. Аналитика</p>
    <p>
      Услуги, описываемые в этом разделе, дают возможность Оператору контролировать и анализировать
      веб-трафик и могут использоваться для фиксирования действий Пользователя.
    </p>
    <p>
      Google Analytics (Google Inc.) Google Analytics – сервис веб-анализа, предлагаемый компанией
      Google Inc. («Google»). Google использует собранные данные для фиксирования и анализа действий
      пользователей в целях подготовки отчетов об операциях, которые выполняет сайт, и их
      последующей передачи другим сервисам Google.
    </p>
    <p>
      Google может использовать собранные данные для того, чтобы генерировать рекламные объявления
      своей собственной рекламной сети с учетом интересов и предпочтений конкретного пользователя.
      Собираемые Персональные данные: данные об использовании сетевых ресурсов и файлы «cookie».
      Место обработки: США – Правила обеспечения конфиденциальности персональных данных – отказ от
      участия.
    </p>
    <p>
      «Яндекс Метрика» – это инструмент веб-аналитики от компании «Яндекс», который помогает
      получать наглядные отчеты, записи действий посетителей, отслеживать источники трафика и
      оценивать эффективность онлайн- и офлайн-рекламы. Персональные данные: данные об использовании
      сетевых ресурсов и файлы «cookie». Место обработки: Российская Федерация – Правила обеспечения
      конфиденциальности персональных данных –
      <a href="https://yandex.ru/support/metrica/ru/general/confidential-data">
        https://yandex.ru/support/metrica/ru/general/confidential-data.
      </a>
    </p>
    <p>5.2. Cookie-файлы, веб-маяки и другие технологии</p>
    <p>
      Сайт собирает информацию о посещениях вами нашего веб-сайта с целью получения статистики
      посещений и эффективности их использования, формирования персонального подхода и адаптации к
      интересам каждого Пользователя. Мы делаем это с помощью различных технологий, одна из которых
      — cookie-файлы. Это данные, которые веб-сайт может отправить вашему браузеру, и они будут
      сохранены на вашем компьютере для последующей идентификации его веб-сайтом.
    </p>
    <p>
      Чаще всего cookie-файлы используются для оценки эффективности веб-сайтов (например, для
      измерения количества посетителей и длительности их пребывания на сайте), выявления наиболее
      интересных и посещаемых тем и страниц, а также для обеспечения удобства навигации и
      пользования сайтом, без сбора какой-либо персональной информации. Также cookie-файлы могут
      быть использованы для формирования персонального подхода на основе уже имеющегося опыта
      взаимодействия пользователя с сайтом и его предпочтениями. С течением времени эта информация
      позволяет улучшить пользовательский опыт.
    </p>
    <p>
      Cookie-файлы обычно делят на сессионные и постоянные. Сессионные cookie-файлы помогают
      эффективно перемещаться по веб-сайту таким образом, что единожды запрошенная в рамках сессии
      информация уже не будет запрашиваться вновь. Сессионные cookie-файлы сохраняются во временной
      памяти и стираются с закрытием браузера. Постоянные cookie-файлы сохраняют пользовательские
      настройки для текущих и последующих визитов. Они сохраняются на жёстком диске компьютера или
      на накопителе мобильного устройства и активизируются при запуске браузера. Мы используем
      постоянные cookie-файлы для сохранения информации, например, о языке и стране пользователя.
    </p>
    <h3>6. Дополнительная информация о сборе и обработке данных</h3>
    <p>6.1. Обращение в суд</p>
    <p>
      Персональные данные Пользователя могут быть использованы в юридических целях Оператором данных
      в суде или на этапах, ведущих к возможному обращению в суд в связи с тем, что сайт или услуги
      использовались ненадлежащим образом.
    </p>
    <p>
      Пользователь осведомлен о том, что Оператор данных может быть вынужден сообщить персональные
      данные по требованию органов государственной власти.
    </p>
    <p>6.2. Дополнительная информация о Персональных данных Пользователя</p>
    <p>
      Помимо информации, содержащейся в настоящих правилах обеспечения конфиденциальности
      персональных данных, сайт может предоставлять Пользователю по запросу дополнительную и
      контекстуальную информацию, касающуюся конкретных услуг и сервисов или сбора и обработки
      Персональных данных.
    </p>
    <p>6.3. Системные журналы и техническое обслуживание</p>
    <p>
      В целях обеспечения работы сайта и его технического обслуживания, сайт и любые сторонние
      сервисы могут вести файлы, в которых регистрируется взаимодействие сайта с Пользователями
      (системные журналы), или использовать с этой целью другие Персональные данные (в частности,
      IP-адрес).
    </p>
    <p>6.4. Информация, отсутствующая в настоящих правилах</p>
    <p>
      Дополнительные сведения, касающиеся сбора или обработки Персональных данных, можно в любое
      время запросить у Оператора путем направления соответствующего письменного обращения по
      юридическому адресу Оператора, указанному в разделе 12 настоящей Политики.
    </p>
    <h3>7. Права Пользователей</h3>
    <p>
      Пользователи вправе обращаться к Оператору по любым вопросам, касающихся обработки его
      Персональных данных, в том числе, чтобы узнать их содержание, проверить их достоверность, или
      попросить их дополнить, аннулировать, обновить или исправить, а также выступить против их
      обработки по всем без исключения законным основаниям. Соответствующие запросы следует
      направлять Оператору данных по юридическому адресу Оператора, указанному в разделе 12
      настоящей Политики.
    </p>
    <p>
      Веб-сайт в настоящее время не распознают автоматизированные команды браузера, касающиеся
      механизмов отслеживания, например, такие как инструкции «не отслеживать», так что вы можете
      самостоятельно настроить обработку браузером cookie-файлов и других технологий в соответствии
      с вашими предпочтениями в области конфиденциальности. В большинстве случаев вы можете включить
      в браузере уведомления об использовании cookie-файлов, чтобы у вас была возможность решить,
      принимать эти условия или нет. Также вы можете вообще отключить cookie-файлы в настройках
      браузера.
    </p>
    <p>
      Некоторые браузеры позволяют включить функцию «не отслеживать», которая посылает сигналы на
      посещаемые вами веб-сайты, показывая, что вы не хотите, чтобы ваши действия на сайте
      отслеживались. Эта функция отличается от блокировки или отключения cookie-файлов, так как
      браузер с включённой функцией «не отслеживать» всё ещё может принимать cookie-файлы. В
      настоящее время не существует отраслевого стандарта, регламентирующего реакцию компаний на
      сигналы «не отслеживать», но в будущем такой стандарт может быть разработан. В настоящее время
      мы не реагируем на сигнал «не отслеживать». Если мы начнём делать это в будущем, то опишем это
      в настоящем Положении о конфиденциальности.
    </p>
    <h3>8. Защита персональных данных</h3>
    <p>
      8.1. Оператор осуществляет надлежащую защиту Персональных данных в соответствии с
      Законодательством Российской Федерации и принимает необходимые и достаточные организационные и
      технические меры для защиты Персональных данных.
    </p>
    <h3>9. Обеспечение информационной безопасности детей</h3>
    <p>
      Веб-сайт не ориентированы на привлечение внимания детей младше 16 лет. Оператор преднамеренно
      не занимается сбором персональных данных детей младше 16 лет и не направляет им никаких
      запросов на предоставление персональной информации.
    </p>
    <h3>
      10. Внесение изменений в настоящие правила обеспечения конфиденциальности персональных данных
    </h3>
    <p>
      Оператор данных оговаривает право в любое время вносить изменения в настоящие правила
      обеспечения конфиденциальности персональных данных, разместив на этой странице уведомление для
      Пользователей. Настоятельно рекомендуется часто проверять эту страницу и дату внесения
      последних изменений, указанную в нижней части страницы.
    </p>
    <p>
      В случае несогласия с любыми изменениями, внесенными в Правила, Пользователь должен прекратить
      пользоваться сайтом и может потребовать, чтобы Оператор данных удалил его Персональные данные.
      Если не указано иное, действующие на тот момент правила обеспечения конфиденциальности
      персональных данных распространяются на все Персональные данные Пользователей, которыми
      располагает Оператор данных.
    </p>
    <h3>11. Правовая информация</h3>
    <p>
      11.1. К настоящей Политике конфиденциальности и отношениям между Пользователем и Оператором,
      возникающим в связи с применением Политики конфиденциальности, подлежит применению право
      Российской Федерации.
    </p>
    <p>
      11.2. Все возможные споры, вытекающие из настоящей Политике конфиденциальности и отношений
      между Пользователем и Оператором, подлежат разрешению в соответствии с действующим
      законодательством по месту регистрации Оператора.
    </p>
    <p>
      Перед обращением в суд Пользователь должен соблюсти обязательный досудебный порядок и
      направить Оператору соответствующую претензию в письменном виде. Срок ответа на претензию
      составляет 30 (тридцать) рабочих дней.
    </p>
    <p>
      11.3. Если по тем или иным причинам одно или несколько положений Политики конфиденциальности
      будут признаны недействительными или не имеющими юридической силы, это не оказывает влияния на
      действительность или применимость остальных положений Политики конфиденциальности.
    </p>
    <p>
      11.4. Оператор имеет право в любой момент изменять Политику конфиденциальности (полностью или
      в части) в одностороннем порядке без предварительного согласования с Пользователем. Все
      изменения вступают в силу с момента ее размещения на Сайте.
    </p>
    <p>
      11.5. Пользователь обязуется самостоятельно следить за изменениями Политики конфиденциальности
      путем ознакомления с актуальной редакцией.
    </p>
    <p>
      11.6. Все предложения или вопросы по настоящей Политике конфиденциальности следует сообщать по
      юридическому адресу Оператора, указанному в разделе 12 настоящей Политики.
    </p>
    <h3>12. Реквизиты Оператора.</h3>
    <table border="1" cellPadding="8" cellSpacing="0" className={styles.Table}>
      <tr>
        <th>Наименование</th>
        <td>ООО «Недвекс»</td>
      </tr>
      <tr>
        <th>ИНН</th>
        <td>2318043183</td>
      </tr>
      <tr>
        <th>ОГРН</th>
        <td>1162366056830</td>
      </tr>
      <tr>
        <th>Юридический адрес</th>
        <td>
          354207, Краснодарский край, город Сочи, Лазаревский район, улица Летняя, строение 15/2
        </td>
      </tr>
    </table>
  </div>
);

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/containers/Landing/PrivacyPolicy.jsx